module.exports = __webpack_public_path__ + "img/Non-verified dashboard Image.0c0dc6c2.svg";